import { z } from 'zod';
import { counter } from './counts.js';
/**
 * The sending-health screen.
 *
 * Rates cross the wire as fractions rather than formatted percentages, because
 * formatting is a presentation decision and the browser is where it belongs —
 * a server that sends "4.2%" has decided the locale, the precision, and that
 * nothing will ever want to compare the number.
 */
const count = counter;
const fraction = z.number().min(0).max(1);
export const dashboardSchema = z.object({
    sentThisWeek: count,
    campaignsThisWeek: count,
    queued: count,
    claimed: count,
    /** Ambiguous sends. Never retried, always someone's job. (I7) */
    unknown: count,
    deadLettered: count,
    bounceRate: fraction,
    complaintRate: fraction,
    subscribedContacts: count,
    totalContacts: count,
    suppressed: count,
});
/**
 * The rates at which mailbox providers start suspending accounts.
 *
 * Shipped as constants rather than as part of the response because they are not
 * facts about this tenant — they are the industry's thresholds, the same for
 * everyone, and a number that never varies has no business being sent over the
 * wire on every request.
 *
 * Nothing pauses sending automatically at these levels yet. The screen shows
 * how close a tenant is and says who acts; it must not claim an automatic
 * protection that does not exist.
 */
export const BOUNCE_RATE_LIMIT = 0.05;
export const COMPLAINT_RATE_LIMIT = 0.001;
//# sourceMappingURL=dashboard.js.map